var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 9.9165L8.00016 12.2498L10.6668 9.9165",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7V12.25",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6492 10.5C14.2021 10.1357 14.6168 9.61568 14.833 9.01555C15.0492 8.41541 15.0556 7.76634 14.8515 7.16251C14.6473 6.55869 14.2431 6.03154 13.6976 5.65755C13.152 5.28357 12.4935 5.08222 11.8176 5.08271H11.0162C10.8249 4.38417 10.467 3.73539 9.96944 3.18522C9.47186 2.63505 8.84757 2.19782 8.14357 1.90645C7.43956 1.61508 6.67419 1.47716 5.90508 1.50308C5.13596 1.529 4.38314 1.71808 3.70329 2.05608C3.02344 2.39408 2.43428 2.8722 1.98016 3.45444C1.52604 4.03669 1.21879 4.70788 1.08155 5.41749C0.94431 6.12711 0.980651 6.85665 1.18784 7.5512C1.39502 8.24574 1.76766 8.8872 2.27769 9.42727",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCloud);
export default __webpack_public_path__ + "static/media/download-cloud.8a009f495087b5af871baab81769389f.svg";
export { ForwardRef as ReactComponent };